import { ScoreTicker } from "./ScoreTicker";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const Layout = ({ children, showTicker = true, showHeader = true, showFooter = true }) => {
  return (
    <div 
      className="min-h-screen bg-[#050505] flex flex-col overflow-x-hidden"
      style={{ 
        minHeight: 'calc(100vh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)'
      }}
    >
      {showTicker && <ScoreTicker />}
      {showHeader && <Header />}
      <main className="flex-1 safe-area-x">
        {children}
      </main>
      {showFooter && <Footer />}
      <div className="noise-overlay" aria-hidden="true" />
    </div>
  );
};

export default Layout;
